import classNames from 'classnames';
import type { ReactNode } from 'react';

export const CardSection = ({
  children,
  className,
  withBorder = false,
  withMargin = true,
}: {
  children: ReactNode | ReactNode[];
  className?: string;
  withBorder?: boolean;
  withMargin?: boolean;
}) => (
  <div
    className={classNames(className, {
      'mb-4 lg:mb-6 [&:last-child]:mb-0': withMargin,
      'border-b border-gray-2': withBorder,
    })}
  >
    {children}
  </div>
);
